/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PhoneNumberLoginToggle } from '../../models/phone-number-login-toggle';

export interface TogglePhoneNumberLogin$Params {

/**
 * Id of a resource.
 */
  id: string;
      body: PhoneNumberLoginToggle
}

export function togglePhoneNumberLogin(http: HttpClient, rootUrl: string, params: TogglePhoneNumberLogin$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
  const rb = new RequestBuilder(rootUrl, togglePhoneNumberLogin.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {"style":"simple","explode":false});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<any>;
    })
  );
}

togglePhoneNumberLogin.PATH = '/api/v1/tenants/{id}/phonenumber_signin';
